import React from 'react';
import './App.css';
import {Route, Routes} from "react-router-dom";
import Home from "./views/home";
import HomeSearch from "./views/home-search";
import PlantClassify from "./views/classify/plant-classify";
import SearchPage from "./views/search/search-page";
import Login from "./views/login/login";
import Manager from "./views/manager/manager";
import BasicLibrary from "./views/manager/basic-library";
import UserManager from "./views/manager/user-manager";
import SpecimenList from "./views/manager/specimen-list";
import PictureList from "./views/manager/picture-list";
import SystemInfo from "./views/manager/system-info";
import DnaList from "./views/dna/dna-list";
import PublicityList from "./views/publicity/publicity-list";
import PublicityDetail from "./views/publicity/publicity-detail";
import PageNotFound from "./views/common/page-not-found";
import BuildingPage from "./views/common/building-page";
import SearchGlobal from "./views/search/search-global";
import AtlasList from "./views/atlas/atlas-list";
import LibraryList from "./views/plant-library/library-list";
import Three from "./views/three/three";
import Science from "./views/manager/science-list";
import { AboutUs } from "./views/home/about-us";
import { AboutUsManager } from "./views/manager/about-us-manager";
import ImageLibrary from "./views/manager/image-library/image-library";
import DnaLibrary from "./views/manager/dna/dna-library";
import CommentList from "./views/manager/comment-list";
import Dashboard from "./views/manager/dashboard";
import "../src/css/global.css"

function App() {
    return (
        <Routes>
            <Route path={"/home"} element={<Home/>}>
                <Route index element={<HomeSearch/>}/>
                <Route path={"/home/search"} element={<HomeSearch/>}/>
                <Route path={"/home/classify"} element={<PlantClassify/>}/>
                <Route path={"/home/dna"} element={<DnaList/>}/>
                <Route path={"/home/publicity"} element={<PublicityList/>}/>
                <Route path={"/home/search/advance"} element={<SearchPage/>}/>
                <Route path={"/home/search/global"} element={<SearchGlobal/>}/>
                <Route path={"/home/atlas"} element={<AtlasList/>}/>
                <Route path={"/home/library"} element={<LibraryList/>}/>
                <Route path={"/home/about-us"} element={<AboutUs/>}/>
                <Route path={"/home/model"} element={<Three/>}/>
                <Route path={"*"} element={<BuildingPage/>}/>
            </Route>
            <Route path={"/home/publicity/detail"} element={<PublicityDetail/>}/>
            <Route path={"/login"} element={<Login/>}/>
            <Route path={"/manager"} element={<Manager/>}>
                <Route path={"/manager/database/basic-library"} element={<BasicLibrary/>}/>
                <Route path={"/manager/database/image-library"} element={<ImageLibrary/>}/>
                <Route path={"/manager/database/dna-library"} element={<DnaLibrary/>}/>
                <Route path={"/manager/permissions/user"} element={<UserManager/>}/>
                <Route path={"/manager/database/specimen"} element={<SpecimenList/>}/>
                <Route path={"/manager/database/picture"} element={<PictureList/>}/>
                <Route path={"/manager/system/web-setting"} element={<SystemInfo/>}/>
                <Route path={"/manager/system/about-us"} element={<AboutUsManager/>}/>
                <Route path={"/manager/science"} element={<Science/>}/>
                <Route path={"/manager/comment"} element={<CommentList/>}/>
                <Route path={"/manager/Dashboard"} element={<Dashboard/>}/>
                <Route path={"*"} element={<BuildingPage/>}/>
            </Route>
            {/*<Route path={"/editor"} element={<Editor/>}/>*/}
            <Route path={"*"} element={<PageNotFound/>}/>
        </Routes>
    );
}

export default App;
